// The consent a PIN is kept with (privacy notice section 6, #698). A PIN is sensitive data, so before LAMP keeps one
// it shows this short message, linking the Privacy Notice in the person's language, and the person agrees by
// confirming. The api records the confirmation, against the current notice version, with the PIN in one step.
// Declining keeps no PIN; the invitation page and Settings → Security both ask through it.
import { useLanguage, useWords } from "../i18n/words.js";
import { noticeHref } from "../legal/Notice.js";
import type { PinConsentGiven } from "./api.js";

export function PinConsent({
  busy,
  decline,
  onConfirm,
  onDecline,
}: {
  busy: boolean;
  /** What declining does, in words: the invitation is accepted without a PIN; in Settings nothing is set. */
  decline: string;
  onConfirm: (consent: PinConsentGiven) => void;
  onDecline: () => void;
}) {
  const w = useWords();
  const { language } = useLanguage();
  return (
    <section className="card" aria-labelledby="pin-consent-heading">
      <h2 id="pin-consent-heading">{w.pinConsentHeading}</h2>
      <p>{w.pinConsentMessage}</p>
      <p>
        <a href={noticeHref("privacy-notice", language)} target="_blank" rel="noreferrer">
          {w.pinConsentNotice}
        </a>
      </p>
      <button
        type="button"
        className="btn btn-go"
        disabled={busy}
        onClick={() => onConfirm({ noticeLanguage: language })}
      >
        {w.pinConsentConfirm}
      </button>{" "}
      <button type="button" className="btn" disabled={busy} onClick={onDecline}>
        {decline}
      </button>
    </section>
  );
}
